export const dateTimePickerStyleOverrides = {
    '.DateTimeRangePicker': {
        flexDir: 'column',
    },
    '.DateTimePicker': {
        display: 'flex',
    },
    '.SearchDateTimePickers .DateTimePicker': {
        width: '100%',
    },
    '.SearchDateTimePickers .TimePicker': {
        ml: '2',
        mb: '4',
        mt: '29px',
    },
    '.SearchDateTimePickers .DatePicker': {
        mr: '2',
        mb: '4',
    },
    '.DatePicker-input-container-with-icon .TextInput .Icon': {
        width: '18px',
        height: 'auto',
    },
    '.TimePicker-with-icon .Select .Select-icon .Icon': {
        width: '18px',
        height: 'auto',
    },
};
